<template>
<div class="chapter">
<div class="inner_page">
<div class="chaptitle"><span><a id="pagexiv"></a><b>TABLES</b></span></div>
<div class="fig"><span><a href="#/ch01#rtab1" id="tab1">Table I.    Confederate Cavalry Units Raised in the Trans-Mississippi during 1861</a></span></div>
<div class="fig"><span><span href="#/ch02#rtab2" id="tab2" title="Link target outside of Sample">Table II.   Confederate Cavalry Units Crossing the Mississippi in the Spring of 1862</span></span></div>
<div class="fig"><span><span href="#/ch02#rtab3" id="tab3" title="Link target outside of Sample">Table III.  Confederate Cavalry Units Raised in Texas by Mid-September, 1862</span></span></div>
<div class="fig"><span><span href="#/ch04#rtab4" id="tab4" title="Link target outside of Sample">Table IV. The Supply of Horses in the Trans-Mississippi</span></span></div>
<div class="fig"><span><span href="#/ch04#rtab5" id="tab5" title="Link target outside of Sample">Table V.  Horses in Marmaduke’s Cavalry Division</span></span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tables.vue?13f8c1c1